import { combineReducers, configureStore } from "@reduxjs/toolkit";

//reducers below
import userReducer from "./slices/userSlice";
import uiReducer from "./slices/uiSlice";
import categorySlice from "./slices/categorySlice";
import searchSlice from "./slices/searchSlice";
import fileManagerSlice from "./slices/fileManagerSlice";
import fileBreadcrumbSlice from "./slices/fileBreadcrumbSlice";
import guestFileBreadcrumbSlice from "./slices/guestFileBreadcrumbSlice";
//reducers above

import storage from "redux-persist/lib/storage";
import persistReducer from "redux-persist/es/persistReducer";

const reducers = combineReducers({
    user: userReducer,
    ui: uiReducer,
    categories: categorySlice,
    searchBar: searchSlice,
    fileManager: fileManagerSlice,
    fileBreadcrumb: fileBreadcrumbSlice,
    guestFileBreadcrumb: guestFileBreadcrumbSlice,
});

const persistConfig = {
    key: 'repo_breadcrumb',
    storage,
    whitelist: ['fileBreadcrumb']
    // whitelist: ['fileBreadcrumb', 'guestFileBreadcrumb']
};

const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
    // reducer: {
    //     user: userReducer,
    //     ui: uiReducer,
    //     categories: categorySlice,
    //     searchBar: searchSlice,
    //     fileManager: fileManagerSlice,
    // },
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
})
